import { render, staticRenderFns } from "./CrudPersonalityDetails.vue?vue&type=template&id=0006d6e8&scoped=true"
import script from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts"
export * from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudPersonalityDetails.vue?vue&type=style&index=0&id=0006d6e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006d6e8",
  null
  
)

export default component.exports